export default __webpack_public_path__ + "static/medical-07ffdf80f64373b4303b1d954b61f9d4.png";